import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// Dimino直接复用Ludo冷启，接口逻辑不变
const GAME_TAG = 'domino'
const ACTIVITY_NAME = 'cold_boot_activity_domino_v3'

export enum PageTypeEnum {
  tasks,
  bag,
}

// 背包列表
export const knapsack_list = createAsyncThunk(
  'DiminoSkin_knapsack_list',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'list' | 'tips'>>
    >(
      '/gamestore/common/knapsack_list',
      {
        ...store.getState().env.deviceinfo,
        activity_name: ACTIVITY_NAME,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 冷启活动任务列表
export const cold_boot_activity = createAsyncThunk(
  'DiminoSkin_cold_boot_activity',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        common_activity_detail?: {
          list?: Array<MissionActivityItemSt>
        }
        activity_time?: string
      }>
    >(
      '/gamestore/common/common_activity_detail',
      {
        ...store.getState().env.deviceinfo,
        activity_name: ACTIVITY_NAME,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 使用皮肤
export const use_game_skin = createAsyncThunk(
  'DiminoSkin_use_mall_game_skin',
  async (arg: {room_id: number; pid: number; type: typeEnum}, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/gamestore/common/use_mall_game_skin',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
        game_tag: GAME_TAG,
        from: ACTIVITY_NAME,
      }
    )
    return resp.data.data
  }
)

// 领取任务奖励
export const cold_boot_activity_reward = createAsyncThunk(
  'DiminoSkin_cold_boot_activity_reward',
  async (arg: {mission_id: number; room_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        err_msg: string
        common_activity?: {
          List?: Array<MissionActivityItemSt>
        }
        reward?: any
      }>
    >('/gamestore/common/common_activity_reward', {
      ...store.getState().env.deviceinfo,
      ...arg,
      activity_name: ACTIVITY_NAME,
    })
    return resp.data.data
  }
)
// 冷启活动任务去完成
export const cold_boot_goto_complete = createAsyncThunk(
  'DiminoSkin_cold_boot_goto_complete',
  async (arg: {room_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        scheme: number
        err_msg: string
      }>
    >('/gamestore/common/game_mission_goto_complete', {
      ...store.getState().env.deviceinfo,
      ...arg,
      game_tag: GAME_TAG,
      from: ACTIVITY_NAME,
    })
    return resp.data.data
  }
)

export enum stateEnum {
  noUse = 0,
  using,
  canUse,
  expired,
}
enum typeEnum {
  //  1骰子皮肤 2棋子皮肤
  dice = 1,
  chessman,
}
export interface game_skin_type {
  id: number
  icon: string
  title: string
  state: stateEnum
  tag: string
  expire_day: number
  type: typeEnum
  pid: number
}
export enum missionStatus {
  goDo = 0,
  received,
  canGet,
  expired,
}
export enum rewardEnum {
  silverCoin = 7,
  skin,
}
interface MissionActivityItemSt {
  mission_id: number
  reward: {
    img_url: string
    reward_cnt: number
    is_box: boolean
    reward_type?: rewardEnum
    reward_msg?: string
  }
  status: missionStatus
  desc: string
  target: number
  current: number
}
interface InitialStateType {
  // 背包列表
  list?: Array<{game_skin?: game_skin_type}>
  tips?: string
  // 任务列表
  common_activity_detail?: {
    list?: Array<MissionActivityItemSt>
  }
  activity_time?: string
}

const initialState: InitialStateType = {}

export const DiminoSkinSlice = createSlice({
  name: 'DiminoSkin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(knapsack_list.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })

    builder.addCase(cold_boot_activity.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(cold_boot_activity_reward.fulfilled, (state, action) => {
      if (action.payload.common_activity && !action.payload.err_msg) {
        Object.assign(state, {
          common_activity_detail: action.payload.common_activity,
        })
      }
    })
  },
})
export default DiminoSkinSlice.reducer
export const DiminoSkinActions = DiminoSkinSlice.actions
